/**
 * Unauthorized page — shown when authenticated user is not staff
 */
import { useAuth } from '@mzanzi/auth'
import { adminAuthOptions } from '@/auth'
import { ShieldOff } from 'lucide-react'

export function UnauthorizedPage() {
  const { logout, user } = useAuth(adminAuthOptions)

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="mx-auto w-full max-w-sm space-y-6 rounded-lg border bg-card p-8 shadow-lg text-center">
        <div className="flex flex-col items-center gap-2">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
            <ShieldOff className="h-6 w-6 text-destructive" />
          </div>
          <h1 className="text-2xl font-bold">Access Denied</h1>
          <p className="text-sm text-muted-foreground">
            {user?.email ? (
              <>
                <strong>{user.email}</strong> is not authorized to access the admin portal.
              </>
            ) : (
              'You are not authorized to access the admin portal.'
            )}
          </p>
          <p className="text-xs text-muted-foreground">
            Contact your administrator if you believe this is an error.
          </p>
        </div>

        <button
          onClick={() => void logout()}
          className="w-full rounded-md border px-4 py-2 text-sm font-medium transition-colors hover:bg-accent"
        >
          Sign out
        </button>
      </div>
    </div>
  )
}
